import { STATES } from 'common/domain/states';

class LoansDetailNewCreditCapacityController {
  constructor($state) {
    'ngInject';
    this.state = $state;

    this.redirectFunctions = {
      'need-a-loan': () => this.state.go(STATES.LOANS.NEED_A_LOAN),
    };
  }
}

export default LoansDetailNewCreditCapacityController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailNewCreditCapacity/loansDetailNewCreditCapacity.controller.js